@if ({ sideTab: sideTabs$ | async, activeTab: activeTab$ | async }; as view) {
  <div data-cy="employment-information-page" class="page-container">
    <div class="row">
      <div class="col-3">
        @if (view.sideTab) {
          <ol class="wizard">
            @for (dt of view.sideTab; track dt) {
              @if (dt.route === view.activeTab.route) {
                <li attr.data-cy="event-{{ dt.route }}-tab-button" class="active" (click)="onTabClick(dt)" tabindex="0" role="button" (keyup.enter)="$event.target.click()">
                  {{ dt.label }}
                </li>
              }
              @if (dt.route !== view.activeTab.route) {
                <li
                  attr.data-cy="event-{{ dt.route }}-tab-button"
                  [ngClass]="{
                    'label-pointer': !dt.isActive,
                    success: dt.isActive,
                  }"
                  (click)="onTabClick(dt)"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="$event.target.click()"
                >
                  {{ dt.label }}
                </li>
              }
            }
          </ol>
        } @else {
          <mat-spinner diameter="50" strokeWidth="2"></mat-spinner>
        }
      </div>
      <div class="col-9">
        <ng-container *ngComponentOutlet="view.activeTab.component"></ng-container>
      </div>
    </div>
  </div>
}
